var _circle, _path, _path2, _circle2, _circle3, _circle4, _path3, _circle5, _line, _circle6, _circle7, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorAccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 156,
    viewBox: "0 0 200 156",
    fill: "none",
    "aria-hidden": "true",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 76,
    r: 70,
    stroke: "#e2e6ec",
    strokeDasharray: "0.1 9",
    strokeLinecap: "round",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 96 C 40 84, 60 118, 88 112",
    fill: "none",
    stroke: "#eaedf0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 26 C 142 18, 166 34, 184 26",
    fill: "none",
    stroke: "#eaedf0",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 52,
    fill: "#92A4A6",
    r: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 42,
    fill: "#9eb9d6",
    r: 2.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 112,
    fill: "#9eb9d6",
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 34 l34 12 v26 c0 22 -14 38 -34 46 c-20 -8 -34 -24 -34 -46 v-26 z",
    fill: "#fff",
    stroke: "#314861",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 70,
    fill: "none",
    r: 8,
    stroke: "#314861",
    strokeWidth: 2.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "#314861",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    x1: 100,
    x2: 100,
    y1: 78,
    y2: 92
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 115,
    fill: "#4D5454",
    r: 20
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 115,
    fill: "none",
    r: 9,
    stroke: "#fff",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    x1: 136.5,
    x2: 149.5,
    y1: 108.5,
    y2: 121.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorAccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-access.40c85a213b977c2126139f1569544335.svg";